import type { InjectionKey } from 'vue';

import type { PasswordHealthService } from '@/application/utils/security/types';

export const passwordHealthServiceKey: InjectionKey<PasswordHealthService> = Symbol('passwordHealthService');
